<template>
  <div class="dish-gallery">
    <!-- 头部区域 -->
    <div class="header">
      <h1 class="title">🍽️ 菜品管理</h1>
      <button class="btn-add" @click="openAddDialog">
        <span class="icon">➕</span> 添加菜品
      </button>
    </div>

    <div class="dish-grid">
      <div v-for="dish in dishList" :key="dish.id" class="dish-card">
        <div class="card-image">
          <img :src="dish.image" :alt="dish.name" />
        </div>
        <div class="card-info">
          <h3 class="dish-name">{{ dish.name }}</h3>
          <span class="dish-category" :class="getCategoryClass(dish.category)">
            {{ dish.category }}
          </span>
        </div>
        <div class="card-actions">
          <button class="btn-edit" @click="openEditDialog(dish)">
            ✏️ 编辑
          </button>
          <button class="btn-delete" @click="deleteDish(dish)">🗑️ 删除</button>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="dishList.length === 0" class="empty-state">
      <div class="empty-icon">📭</div>
      <p>暂无菜品，点击上方按钮添加</p>
    </div>

    <!-- 添加/编辑菜品弹窗 -->
    <div v-if="dialogVisible" class="dialog" @click.self="closeDialog">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>{{ isEdit ? "✏️ 编辑菜品" : "➕ 添加菜品" }}</h3>
          <button class="btn-close" @click="closeDialog">&times;</button>
        </div>

        <div class="form-group">
          <label>菜品名称</label>
          <input
            type="text"
            v-model="currentDish.name"
            placeholder="请输入菜品名称"
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label>分类</label>
          <select v-model="currentDish.category" class="form-select">
            <option value="炒菜">🔥 炒菜</option>
            <option value="炖肉">🍖 炖肉</option>
            <option value="凉菜">🥗 凉菜</option>
            <option value="海鲜">🦞 海鲜</option>
            <option value="汤类">🥣 汤类</option>
            <option value="主食">🍚 主食</option>
            <option value="粥粉类">🥣 粥粉类</option>
            <option value="小吃/特色">🍢 小吃/特色</option>
            <option value="火锅/干锅/麻辣">🥘 火锅/干锅/麻辣</option>
            <option value="水果/饮品">🍉 水果/饮品</option>
          </select>
        </div>

        <div class="form-group">
          <label>菜品图片</label>
          <div class="upload-area" @click="triggerFileInput">
            <input
              type="file"
              ref="fileInput"
              @change="handleImageChange"
              accept="image/*"
              style="display: none"
            />
            <div v-if="!currentDish.image" class="upload-placeholder">
              <span class="upload-icon">📷</span>
              <span>点击上传图片</span>
            </div>
            <div v-else class="upload-preview">
              <img :src="currentDish.image" alt="preview" />
              <button
                class="btn-remove-img"
                @click.stop="currentDish.image = ''"
              >
                ✖
              </button>
            </div>
          </div>
        </div>

        <div class="dialog-footer">
          <button class="btn-cancel" @click="closeDialog">取消</button>
          <button class="btn-save" @click="saveDish">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "DishGallery",
  data() {
    return {
      dialogVisible: false,
      isEdit: false,
      currentDish: { name: "", category: "", image: "" },
      dishList: [],
    };
  },
  mounted() {
    this.dish_gallery_simple();
  },
  methods: {
    async dish_gallery_simple() {
      const res = await request.get(`/profile/get/dish_gallery_simple`);
      console.log(res);
      this.dishList = res.data.dishes;
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentDish = { name: "", category: "炒菜", image: "" };
      this.dialogVisible = true;
    },
    openEditDialog(dish) {
      this.isEdit = true;
      this.currentDish = { ...dish };
      this.dialogVisible = true;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const typeMap = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
        "image/webp": "webp",
      };
      const extension = typeMap[file.type] || "jpg";
      const newFileName = `${Date.now()}.${extension}`;
      const renamedFile = new File([file], newFileName, { type: file.type });

      const formData = new FormData();
      formData.append("file", renamedFile);

      const res = await request.post("/pic/dish_gallery", formData);
      console.log(res);
      if (res.success) {
        this.currentDish.image = res.url;
      } else {
        alert("上传失败：" + res.data.message);
      }
    },
    saveDish() {
      if (this.isEdit) {
        this.updateDish();
      } else {
        this.addDish();
      }
    },
    async addDish() {
      const res = await request.post("/houtai/addDish", {
        currentDish: this.currentDish,
      });
      if (res.code === 200) {
        this.dialogVisible = false;
        alert("菜品添加成功");
        this.dish_gallery_simple();
      }
    },
    async updateDish() {
      const res = await request.post("/houtai/updateDish", {
        currentDish: this.currentDish,
      });

      console.log('111111111111',res);
      

      if (res.code === 200) {
        this.dialogVisible = false;
        alert("菜品编辑成功");
        this.dish_gallery_simple();
      }
    },
    async deleteDish(dish) {
      const id = dish.id;
      const imgurl = dish.image;

      if (confirm("确认删除该菜品吗？")) {
        const res = await request.post("/houtai/deleteDish", {
          id: id,
          imgurl: imgurl,
        });

        if (res.code === 200) {
          alert("菜品删除成功");
          this.dish_gallery_simple();
        }
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    getCategoryClass(category) {
      const map = {
        炒菜: "cat-stir",
        炖肉: "cat-braise",
        凉菜: "cat-cold",
        海鲜: "cat-seafood",
        汤类: "cat-soup",
      };
      return map[category] || "";
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-gallery {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 30px;
}

/* 头部样式 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}

.title {
  font-size: 22px;
  color: #333;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-add {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.dish-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  max-width: 1400px;
  margin: 0 auto;
}

/* 卡片样式 */
.dish-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.card-image {
  width: 100%;
  height: 140px;
  overflow: hidden;
  background: #f0f0f0;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.dish-card:hover .card-image img {
  transform: scale(1.05);
}

.card-info {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.dish-name {
  font-size: 14px;
  color: #333;
  font-weight: 400;
  margin: 0;
}

.dish-category {
  padding: 3px 5px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}

.cat-stir {
  background: #ff6b6b;
  color: white;
}
.cat-braise {
  background: #ffa502;
  color: white;
}
.cat-cold {
  background: #2ed573;
  color: white;
}
.cat-seafood {
  background: #1e90ff;
  color: white;
}
.cat-soup {
  background: #ff7f50;
  color: white;
}

.card-actions {
  padding: 10px 12px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 8px;
}

.btn-edit,
.btn-delete {
  flex: 1;
  padding: 6px 0;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.btn-edit {
  background: #e8f4fd;
  color: #3498db;
}

.btn-edit:hover {
  background: #3498db;
  color: white;
}

.btn-delete {
  background: #fee2e2;
  color: #e74c3c;
}

.btn-delete:hover {
  background: #e74c3c;
  color: white;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  grid-column: span 2;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state p {
  color: #999;
  font-size: 16px;
}

/* 弹窗样式 */
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.dialog-content {
  background-color: white;
  border-radius: 20px;
  width: 450px;
  max-width: 90%;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.dialog-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.btn-close:hover {
  color: #333;
}

.form-group {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 8px;
}

.form-input,
.form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #667eea;
}

/* 上传区域 */
.upload-area {
  cursor: pointer;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  border: 2px dashed #ddd;
  border-radius: 12px;
  background: #fafafa;
  transition: all 0.2s;
}

.upload-placeholder:hover {
  border-color: #667eea;
  background: #f5f3ff;
}

.upload-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.upload-preview {
  position: relative;
  display: inline-block;
}

.upload-preview img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 12px;
}

.btn-remove-img {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-footer {
  padding: 20px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel,
.btn-save {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn-cancel {
  background: #f0f0f0;
  color: #666;
}

.btn-cancel:hover {
  background: #e0e0e0;
}

.btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-save:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 响应式：屏幕较小时自动减少列数 */
@media (max-width: 1200px) {
  .dish-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 900px) {
  .dish-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .dish-gallery {
    padding: 16px;
  }

  .dish-grid {
    gap: 5px;
    grid-template-columns: repeat(2, 1fr);
  }

  .card-image {
    height: 130px;
  }

  .dish-name {
    font-size: 14px;
  }

  .title {
    font-size: 17px;
  }
}
</style>